import React from 'react';
import PropTypes from 'prop-types';
import FooterRebrand from './footer';

const FooterWrapper = ({ includeFooter, footerRebrandContent }) => (
  <FooterRebrand footerContent={footerRebrandContent} includeFooter={includeFooter} />
);

FooterWrapper.propTypes = {
  includeFooter: PropTypes.bool,
  footerRebrandContent: PropTypes.shape({}).isRequired,
};

FooterWrapper.defaultProps = {
  includeFooter: true,
};

export default FooterWrapper;
